<template>
	<div id='ticket'>
		<mt-header :title="title" fixed>
		   <a href="javascript:void(0)" slot="left" @click="returnBack">
			    <mt-button icon="back" class="font-Yahei"></mt-button>
		   </a>
		   <a href="javascript:void(0)" slot="right" @click="backHome">
			    <img src='../../../static/images/home_ico_white.png' width="27"/>
		   </a>
		</mt-header>
		<main>
			<ul class='ticket-tab'>
				<li :class="{active:tab==1}" @click="changeTab(1)">
					<span>未使用({{notUsedCount}})</span>
					<span></span>
				</li>
				<li :class="{active:tab==2}" @click='changeTab(2)'><span>已使用({{alreadyUsedCount}})</span><span></span></li>
				<li :class="{active:tab==3}" @click='changeTab(3)'><span>已失效({{expiredCount}})</span><span></span></li>
			</ul>
			<div class='ticket-list'>
				<!--<mt-loadmore :bottom-method='loadBottom' :bottom-all-loaded="allLoaded" :auto-fill=false ref='loadmore'>-->
				<div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
					<ul>
						<li v-for='data in dataList' :class="[{'unused':tab==1},{'used':tab==2},{'expired':tab==3}]">
							<div class="ticketwarp-buttom">
								<div>
								<span class='ticket-money'><span>￥</span><span class='ticket-num'>{{data.yamount}}</span></br><span v-show="data.fullamount!=-1">满{{data.fullamount}}元可用</span></span><span class="ticket-range">{{data.yname}}</span><span class='ticket-use' v-show='tab==1'><a @click='routeTo("/Category")'>立即使用</a></span><span class='ticket-invalid' v-show='tab==3'><img src="../../../static/images/invalid.png"/></span>
								</div>
							</div>
							<div class='ticket-timelimit'>
								<div>有效期：{{formatDate(data.startDate)}}-{{formatDate(data.endDate)}}</div>
								<div class="mtp1" v-show="tab==2">使用时间：{{data.payTime}}</div>
							    <div class="qqdot dotleft"></div>
							    <div class="qqdot dotright"></div>
							</div>
						</li>
					</ul>
				 <!--<p v-show="loadingTextBtn==false && dataList.length>3" class="text-center font-size7 heightmargin bgf3f3f3 colord6d6d6"><span class="colord6d6d6 mr10">——————</span>我是有底线的<span class="colord6d6d6 ml10">——————</span></p>-->
		 		 <div class="loading-text" v-show="loadingTextBtn==true">
		 		 	<span class="text-center inline-block mt5">
		 		 		<label v-text="loadingText" class="float-left font-size7"></label>
		 		 		<mt-spinner class="float-left ml5" v-show="loadingComplete==false" type="snake" :size="10"></mt-spinner>
		 		 	</span>
		 		 </div>	
				</div>
				<!--</mt-loadmore>-->
				<div class='ticket-nomore' v-show='allLoaded && dataList.length>0 && loadingTextBtn!=true'>
					<img src="../../../static/images/nomore.png"/>
				</div>
			</div>
			<div v-show='dataList.length==0' class='noData'>暂无优惠券</div>
		</main>
	</div>
</template>

<script>
	import { Toast } from 'mint-ui'
//	import { Loadmore } from 'mint-ui'
	export default{
		data(){
			return{
				title:'优惠券',
				tab: 1,
				uid: localStorage.getItem('username'),
				notUsedCount: 0, //未使用优惠券总数
				alreadyUsedCount: 0, //已使用优惠券总数
				expiredCount: 0, //已过期优惠券总数
				currentPage: 1, //当前页
				pageSize: 10, //每页显示条数
				dataList: false,
				allLoaded: false, //数据是否全部加载
				loadingText:"加载中",
                loading:false,
                loadingTextBtn:"",
                totalPages:"",
                loadingComplete:false,
                 md5sign:this.Act_md5sign,
                 signMd:"",
                 isuse:""
			}
		},
//		components: {
//			'mt-loadmore': Loadmore
//		},
		created:function(){
			this.getTotal();
			this.changeTab(1);
	    },
	    methods: {
			returnBack(){
	       	 	this.$router.go(-1);
	     	},
	     	backHome(){
	     		this.$router.push({path: '/'});
	     	},
	     	routeTo(path){
	     		this.$router.push({path: path});
	     	},
			changeTab(type){
				this.tab = type;
				this.currentPage = 1;
				this.dataList = false;
				this.allLoaded = false;
				this.getCoupon();
			},
			getTotal(){ //获取各类优惠券总数
				this.signMd=md5('uid='+this.uid+'&'+this.md5sign);
				this.$http.post(this.URL_PREFIX+"/activity/findCouponStateCount.net",{uid:this.uid,sign:this.signMd})
				  .then((res) =>{
			  		switch(res.data.code){
			  			case 200:
				  			this.notUsedCount = res.data.obj.notUsed;
				  			this.alreadyUsedCount = res.data.obj.alreadyUsed;
				  			this.expiredCount = res.data.obj.expired;
				  			break;
				  		default:
				  			Toast(res.data.msg);
			  		}
			  	})
			},
			formatDate(date){
				return date.substr(0,10).replace(/[-]/g,".");
			},
			loadBottom() {
				this.currentPage++
				this.getCoupon()
				this.$refs.loadmore.onBottomLoaded();// 固定方法，查询完要调用一次，用于重新定位
			},
			getCoupon() { //获取优惠券
				this.signMd=md5('uid='+this.uid+'&isuse='+this.tab+'&'+this.md5sign);
				this.$http.post(this.URL_PREFIX+"/activity/findCouponOrder.net",{uid:this.uid,isuse:this.tab,sign:this.signMd,page:this.currentPage,rows:this.pageSize})
				  .then((res) =>{
				  	this.totalPages=res.data.pageSize;
			  		switch(res.data.code){
			  			case 200:
				  			this.dataList = this.currentPage == 1 ?  res.data.rows : this.dataList.concat(res.data.rows)
				  			this.allLoaded = (res.data.total <= this.dataList.length)
				  			break;
				  		case 0:
				  			this.dataList = []
				  			break;
				  		default:
				  			this.dataList = []
				  			Toast(res.data.msg);
			  		
			  		}
			  	});
			},
			 //加载更多
		    loadMore(){
		      this.signMd=md5('uid='+this.uid+'&isuse='+this.tab+'&'+this.md5sign);
		      this.loading = true;
		      setTimeout(() => {
		      this.loadingTextBtn=true;
	          this.currentPage++;
	          if(this.currentPage<=this.totalPages){
	            this.$http.post(this.URL_PREFIX+"/activity/findCouponOrder.net",{uid:this.uid,isuse:this.tab,sign:this.signMd,page:this.currentPage,rows:this.pageSize})
		  	    .then((res) =>{
		  	  	     this.dataList=this.dataList.concat(res.data.rows);
		  	    });
	          }else{
	            this.loadingText="";
	            this.loadingComplete=true;
	            this.loadingTextBtn=false;
	            this.allLoaded = true;
	          }
	            this.loading = false;
	            
	        }, 2500);
		    }
	    }
	  }
</script>

<style scoped="scoped">
	.mtp2{margin-top: 1%;}
	#ticket {
		height: 100%;
		background: #f3f3f3;
	}
	#ticket main {
		margin-top: 40px;
	}
	.ticket-tab {
		display: flex;
		background: #fff;
	}
	.ticket-tab > li {
		flex: 1;
		text-align: center;
	}
	.ticket-tab > li > span:first-of-type {
		display: block;
		color: #666;
		font-size: 16px;
		line-height: 40px;
	}
	.ticket-tab > li.active > span{
		color: #FF892A;
		border-collapse: 50%;
	}
	.ticket-tab > li.active > span:last-of-type {
		width: 40%;
		display: block;
		margin: 0 auto;
		height: 2px;
		background: #FF892A;
	}
	div.ticket-list {
		padding-top: 10px;
	}
	.ticket-list li {
		margin: 5px 4%;
		color: #fff;
		font-size: 1.3em;
		position: relative;
	}
	.ticket-list li.unused {
		/*background: url(../../../static/images/sale.png) no-repeat;
		background-size: 100% auto;*/
		background: -webkit-linear-gradient(left, #ff6067 , #fea370); /* Safari 5.1 - 6.0 */
	    background: -o-linear-gradient(right, #ff6067, #fea370); /* Opera 11.1 - 12.0 */
	    background: -moz-linear-gradient(right, #ff6067, #fea370); /* Firefox 3.6 - 15 */
	    background: linear-gradient(to right, #ff6067 , #fea370); /* 标准的语法 */
	    border-radius:5px ;
	}
	.ticketwarp-buttom{
		border-bottom: 1px dashed #E5E5E5;
		overflow: hidden;
		position: relative;
	}
	.qqdot{
		position: absolute;
		width: 14px;
		height: 14px;
		border-radius: 50%;
		background: #eee;
	}
	.dotleft{
		top: -7px;
		left: -7px;
	}
	.dotright{
		right: -7px;
		top: -7px;
	}
	.ticket-list li.used {
		/*background: url(../../../static/images/unsale.png) no-repeat;
		background-size: 100% auto;*/
		background: -webkit-linear-gradient(left, #ccc , #ccc); /* Safari 5.1 - 6.0 */
	    background: -o-linear-gradient(right, #ccc, #ccc); /* Opera 11.1 - 12.0 */
	    background: -moz-linear-gradient(right, #ccc, #ccc); /* Firefox 3.6 - 15 */
	    background: linear-gradient(to right, #ccc , #ccc); /* 标准的语法 */
	    border-radius:5px ;
	}
	.ticket-list li.expired {
		/*background: url(../../../static/images/unsale.png) no-repeat;
		background-size: 100% auto;*/
		background: -webkit-linear-gradient(left, #ccc , #ccc); /* Safari 5.1 - 6.0 */
	    background: -o-linear-gradient(right, #ccc, #ccc); /* Opera 11.1 - 12.0 */
	    background: -moz-linear-gradient(right, #ccc, #ccc); /* Firefox 3.6 - 15 */
	    background: linear-gradient(to right, #ccc , #ccc); /* 标准的语法 */
	    border-radius:5px ;
	}
	.ticket-list li > div:last-of-type {
	}
	.ticket-list li > div:first-of-type{
	}
	.ticket-list li .ticket-money {
		overflow: hidden;
	    padding: 5% 4% 5% 4%;
	    float: left;
	}
	.ticket-list li .ticket-money > span:first-of-type {
		font-size: 1.3em;
	}
	.ticket-list li .ticket-num {
		font-size: 30px;
	}
	.ticket-list li .ticket-range {
		font-size: 14px;
		position: relative;
		float: left;
		margin: 8% 0% 5% 0%;
		width: 50%;
	}
	.ticket-list li .ticket-use {
		position: absolute;
		top:35%;
		right:8%;
	}
	.ticket-list li .ticket-use > a {
		padding:8% 16%;
		border-radius: 14px;
		font-size: 1em;
		background: #fff;
		color: #f00;
		white-space: nowrap;
	}
	.ticket-use > img {
		width: 60px;
		
	}
	.ticket-invalid > img{
		width: 18%;
	    position: absolute;
	    right: 3%;
	    top: 5%;
	}
	.ticket-timelimit {
		position: relative;
		padding: 2% 2% 2% 6%;
	}
	.ticket-nomore {
		margin-top: 20px;
		text-align: center;
	}
	.ticket-nomore > img {
		width:50%;
	}
	.noData {
		text-align: center;
	    font-size: 15px;
	    margin-top: 20%;
	    color: #999;
	}
	.loading-text{text-align: center;color: #666;font-size: 0.8rem;}
    .heightmargin{height: 25px;}
</style>


// WEBPACK FOOTER //
// src/views/Ticket/ticket.vue